import { FieldData as TFieldData } from "@/@client/Theasoft_Data"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { LabeledValue } from "@components/default-list/labeled-value"
import { DefaultListItem } from "@components/default-list/list-item"
import { FieldData } from "@components/field-data"
import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface Props {
  fieldsGrouped: [string, TFieldData[]][]
}

export function ContractFieldsCard({ fieldsGrouped }: Props) {
  const { t } = useTranslation("app_server")
  if (fieldsGrouped.flatMap((g) => g[1]).length === 0) return null

  return (
    <DetailsCard title={t("ContractFields")}>
      {fieldsGrouped.map((group, i) => (
        <React.Fragment key={i}>
          <Text fz={"lg"} fw={"bold"}>
            {group[0]}
          </Text>
          {group[1].map((field, i) => (
            <DefaultListItem key={i}>
              <LabeledValue
                label={field.name}
                value={<FieldData fieldData={field} />}
              />
            </DefaultListItem>
          ))}
        </React.Fragment>
      ))}
    </DetailsCard>
  )
}
